import {SelectionModel} from '@angular/cdk/collections';
import {FlatTreeControl} from '@angular/cdk/tree';
import {Component, Injectable,OnInit, Input, Output, EventEmitter} from '@angular/core';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';
import {BehaviorSubject,Observable} from 'rxjs';
import Swal from 'sweetalert2';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { lang_focus } from 'app/idiomas/i18n/focus/focus.lang';
/**
* Node for to-do item
*/
export class TodoItemNode {
  children: TodoItemNode[];
  item: string;
}

/** Flat to-do item node with expandable and level information */
export class TodoItemFlatNode {
  item: string;
  level: number;
  expandable: boolean;
}

/**
* The Json object for to-do list data.
*/
const TREE_DATA = {
  Groceries: {
    'Almond Meal flour': null,
    'Organic eggs': null,
    'Protein Powder': null,
    Fruits: {
      Apple: null,
      Berries: ['Blueberry', 'Raspberry'],
      Orange: null
    }
  },
  Reminders: [
    'Cook dinner',
    'Read the Material Design spec',
    'Upgrade Application to Angular'
  ]
};

/**
* Checklist database, it can build a tree structured Json object.
* Each node in Json object represents a to-do item or a category.
* If a node is a category, it has children items and new items can be added under the category.
*/
@Injectable()
export class ChecklistDatabase{
  dataChange = new BehaviorSubject<TodoItemNode[]>([]);

  get data(): TodoItemNode[] { return this.dataChange.value; }

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
  ) {
    // this.initialize();
    lang_focus.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }



  initialize(datos) {
    // Build the tree nodes from Json object. The result is a list of `TodoItemNode` with nested
    //     file node as children.
    const data = this.buildFileTree(datos, 0);

    // Notify the change.
    this.dataChange.next(data);
  }

  /**
  * Build the file structure tree. The `value` is the Json object, or a sub-tree of a Json object.
  * The return value is the list of `TodoItemNode`.
  */
  buildFileTree(obj: {[key: string]: any}, level: number): TodoItemNode[] {
    return Object.keys(obj).reduce<TodoItemNode[]>((accumulator, key) => {
      const value = obj[key];
      const node = new TodoItemNode();
      node.item = key;

      if (value != null) {
        if (typeof value === 'object') {
          node.children = this.buildFileTree(value, level + 1);
        } else {
          node.item = value;
        }
      }

      return accumulator.concat(node);
    }, []);
  }

  /** Add an item to to-do list */
  insertItem(parent: TodoItemNode, name: string) {
    if (parent.children) {
      parent.children.push({item: name} as TodoItemNode);
      this.dataChange.next(this.data);
    }
  }

  updateItem(node: TodoItemNode, name: string) {
    node.item = name;
    this.dataChange.next(this.data);
  }

  deleteItem(parent: TodoItemNode, item: string): void {
    console.log('parent:',parent);

    if (parent.children) {
      parent.children = parent.children.filter(c => c.item !== item);
      this.dataChange.next(this.data);
    }

  }
}

/**
* @title Tree with checkboxes
*/
@Component({
  selector: 'arbol-filtros',
  templateUrl: './arbol-filtros.component.html',
  styleUrls: ['./arbol-filtros.component.scss'],
  providers: [ChecklistDatabase]
})
export class ArbolFiltrosComponent implements OnInit {
  @Input() jsonArbolArmado: Observable<any>;
  @Output() datosFiltrosColaboradores: EventEmitter<any> = new EventEmitter();
  @Output() filtroRemovido: EventEmitter<any> = new EventEmitter();
  jsonArmadoFiltros:any;
  /** Map from flat node to nested node. This helps us finding the nested node to be modified */
  flatNodeMap = new Map<TodoItemFlatNode, TodoItemNode>();

  /** Map from nested node to flattened node. This helps us to keep the same object for selection */
  nestedNodeMap = new Map<TodoItemNode, TodoItemFlatNode>();

  /** A selected parent node to be inserted */
  selectedParent: TodoItemFlatNode | null = null;

  /** The new item's name */
  newItemName = '';

  treeControl: FlatTreeControl<TodoItemFlatNode>;

  treeFlattener: MatTreeFlattener<TodoItemNode, TodoItemFlatNode>;

  dataSource: MatTreeFlatDataSource<TodoItemNode, TodoItemFlatNode>;

  /** The selection for checklist */
  checklistSelection = new SelectionModel<TodoItemFlatNode>(true /* multiple */);
  opcionesSelecionadas:any[]=[];
  filtrosIniciales:any;
  constructor(
  private _database: ChecklistDatabase,
  private _fuseTranslationLoaderService: FuseTranslationLoaderService,
  private translateSrv: TranslateService,) {
    this.treeFlattener = new MatTreeFlattener(this.transformer, this.getLevel,
      this.isExpandable, this.getChildren);
      this.treeControl = new FlatTreeControl<TodoItemFlatNode>(this.getLevel, this.isExpandable);
      this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

      _database.dataChange.subscribe(data => {
        this.dataSource.data = data;
      });
    }

    ngOnInit() {
      this.jsonArmadoFiltros = this.jsonArbolArmado.subscribe( (datos:any) => {
        console.log('datos:',datos);
        this.filtrosIniciales=datos;
        this._database.initialize(datos);

      });
    }


    getLevel = (node: TodoItemFlatNode) => node.level;

    isExpandable = (node: TodoItemFlatNode) => node.expandable;

    getChildren = (node: TodoItemNode): TodoItemNode[] => node.children;

    hasChild = (_: number, _nodeData: TodoItemFlatNode) => _nodeData.expandable;

    hasNoContent = (_: number, _nodeData: TodoItemFlatNode) => _nodeData.item === '';

    /**
    * Transformer to convert nested node to flat node. Record the nodes in maps for later use.
    */
    transformer = (node: TodoItemNode, level: number) => {
      const existingNode = this.nestedNodeMap.get(node);
      const flatNode = existingNode && existingNode.item === node.item
      ? existingNode
      : new TodoItemFlatNode();
      flatNode.item = node.item;
      flatNode.level = level;
      flatNode.expandable = !!node.children;
      this.flatNodeMap.set(flatNode, node);
      this.nestedNodeMap.set(node, flatNode);
      return flatNode;
    }

    /** Whether all the descendants of the node are selected. */
    descendantsAllSelected(node: TodoItemFlatNode): boolean {
      const descendants = this.treeControl.getDescendants(node);
      const descAllSelected = descendants.every(child =>
        this.checklistSelection.isSelected(child)
      );
      return descAllSelected;
    }

    /** Whether part of the descendants are selected */
    descendantsPartiallySelected(node: TodoItemFlatNode): boolean {
      const descendants = this.treeControl.getDescendants(node);
      const result = descendants.some(child => this.checklistSelection.isSelected(child));
      return result && !this.descendantsAllSelected(node);
    }

    /** Toggle the to-do item selection. Select/deselect all the descendants node */
    todoItemSelectionToggle(node: any): void {
      console.log('node',node);

      this.checklistSelection.toggle(node);
      const descendants = this.treeControl.getDescendants(node);
      this.checklistSelection.isSelected(node)
      ? this.checklistSelection.select(...descendants)
      : this.checklistSelection.deselect(...descendants);

      // Force update for the parent
      descendants.every(child =>
        this.checklistSelection.isSelected(child)
      );
      this.checkAllParentsSelection(node);
      this.onLeafNodeClick(node);
    }

    /** Toggle a leaf to-do item selection. Check all the parents to see if they changed */
    todoLeafItemSelectionToggle(node: any): void {
      this.checklistSelection.toggle(node);
      this.checkAllParentsSelection(node);
      this.onLeafNodeClick(node);
    }

    /* Checks all the parents when a leaf node is selected/unselected */
    checkAllParentsSelection(node: TodoItemFlatNode): void {
      let parent: TodoItemFlatNode | null = this.getParentNode(node);
      while (parent) {
        this.checkRootNodeSelection(parent);
        parent = this.getParentNode(parent);
      }
    }

    /** Check root node checked state and change it accordingly */
    checkRootNodeSelection(node: TodoItemFlatNode): void {
      const nodeSelected = this.checklistSelection.isSelected(node);
      const descendants = this.treeControl.getDescendants(node);
      const descAllSelected = descendants.every(child =>
        this.checklistSelection.isSelected(child)
      );
      if (nodeSelected && !descAllSelected) {
        this.checklistSelection.deselect(node);
      } else if (!nodeSelected && descAllSelected) {
        this.checklistSelection.select(node);
      }
    }

    /* Get the parent node of a node */
    getParentNode(node: TodoItemFlatNode): TodoItemFlatNode | null {
      const currentLevel = this.getLevel(node);

      if (currentLevel < 1) {
        return null;
      }

      const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;

      for (let i = startIndex; i >= 0; i--) {
        const currentNode = this.treeControl.dataNodes[i];

        if (this.getLevel(currentNode) < currentLevel) {
          return currentNode;
        }
      }
      return null;
    }

    /** Select the category so we can insert the new item. */
    addNewItem(node: TodoItemFlatNode) {
      console.log('node:',node);
      const parentNode = this.flatNodeMap.get(node);
      console.log('parentNode:',parentNode);

      // this._database.insertItem(parentNode!, '');
      // this.treeControl.expand(node);
    }

    /** Save the node to database */
    saveNode(node: TodoItemFlatNode, itemValue: string) {
      const nestedNode = this.flatNodeMap.get(node);
      this._database.updateItem(nestedNode!, itemValue);
    }

    deleteItem(node: TodoItemFlatNode): void {
      console.log('node:',node);

      // Get the parent node of the selected child node
      const parentNode = this.getParentNode(node);
      console.log('parentNode:',parentNode);
      // Map from flat node to nested node.
      const parentFlat = this.flatNodeMap.get(parentNode);
      console.log('parentFlat:',parentFlat);
      this._database.deleteItem(parentFlat!, node.item);
      this.treeControl.expand(node);

    }

    onLeafNodeClick(node: TodoItemNode): void {
      const ancestors = this.getAncestors(this.dataSource.data, node.item);
      console.log("ancestors ", ancestors);

      // this.treeControl.collapse(ancestors[0]);
      console.log("direct parent  ", ancestors[ancestors.length - 2]);
      let breadcrumbs = "";
      ancestors.forEach(ancestor => {
        breadcrumbs += `${ancestor.item}/`;
      });
      console.log("breadcrumbs ", breadcrumbs);
      this.obtieneOpcionesFiltros(ancestors);
    }

    getAncestors(array, name) {
      if (typeof array != "undefined") {
        for (let i = 0; i < array.length; i++) {
          if (array[i].item === name) {
            return [array[i]];
          }
          const a = this.getAncestors(array[i].children, name);
          if (a !== null) {
            a.unshift(array[i]);
            return a;
          }
        }
      }
      return null;
    }

    obtieneOpcionesFiltros(filtro){
      let nombreCategoria=filtro[0].item;
      let categoria:any={};
      let indiceCategoria= this.opcionesSelecionadas.findIndex(item=> item.key== nombreCategoria);
      console.log("filtro seleccionado",filtro);
      if (filtro.length==1) { ////cuando se selecciona toda la categoria
        if (indiceCategoria==-1) { //no existe la categoria
          categoria={
            key: nombreCategoria,
            options: [],
          }
          filtro[0].children.forEach(opcionFiltro => {
            categoria.options.push(opcionFiltro.item);
          });
          this.opcionesSelecionadas.push(categoria);
        }else{
          if (this.opcionesSelecionadas[indiceCategoria].options.length!= filtro[0].children.length) {
            filtro[0].children.forEach(opcionPosibles => {
              if (!this.opcionesSelecionadas[indiceCategoria].options.includes(opcionPosibles.item)) {
               this.opcionesSelecionadas[indiceCategoria].options.push(opcionPosibles.item);
              }
            });
          }else{
            this.opcionesSelecionadas.splice(indiceCategoria,1);
          }
        }
      }else if (filtro.length==2) { ////cuando se selecciona una opción de la categoria
        if (indiceCategoria!=-1) {  //ya se guardo la categoria
          let indiceOpcion= this.opcionesSelecionadas[indiceCategoria].options.findIndex(item=>item==filtro[1].item);
          if (indiceOpcion !=-1) { ///existe la opcion
            this.opcionesSelecionadas[indiceCategoria].options.splice(indiceOpcion,1);
            if (this.opcionesSelecionadas[indiceCategoria].options.length==0) {
              this.opcionesSelecionadas.splice(indiceCategoria,1);
            }
          }else{
            this.opcionesSelecionadas[indiceCategoria].options.push(filtro[1].item);
          }
        }else{ ////cuando la categoria no existe
          categoria={
            key: nombreCategoria,
            options: [filtro[1].item],
          }
          this.opcionesSelecionadas.push(categoria);
        }
      }
      console.log('opcionesSelecionadas: ',this.opcionesSelecionadas);

    }

 quitarCategoria(node: any){
   delete this.filtrosIniciales[node.item];
   // node.removeChild(node.item);
   this._database.initialize(this.filtrosIniciales);
   this.filtroRemovido.emit(node.item);
   this.opcionesSelecionadas = [];
 }


 envioFiltros(){
   console.log('checklistSelection: ',this.checklistSelection.selected);
this.datosFiltrosColaboradores.emit(this.opcionesSelecionadas);
this.modalGuardado();
 }

 modalGuardado(){
   let mensaje= this.translateSrv.instant('LANDINFOCUS.STEP_COLAB.STEP_2.MODALES.MODAL_BUSCA_COLAB')

   Swal.fire({
     title: mensaje,
     allowOutsideClick: false,
     didOpen: () => {
       Swal.showLoading()
     }
   });
 }

  }
